import React from "react";
import Page from "@jumbo/shared/Page";
import Children from "../pages/parent/Children";
import Programs from "../pages/parent/Programs";
import Dashboard from "../pages/parent/Dashboard";
import Subscription from "../pages/parent/Subscription";
import Profile from "../pages/parent/Profile"
import Appointments from "../pages/parent/Appointments";
import Bookings from "../pages/parent/Bookings";
import Progress from "../pages/common/Progress";

const adminroutes = [
    {
        path: ["/dashboard", "/dashboard/:status/:message"],
        element: <Page component={Dashboard}/>,
    },
    {
        path: [
            "/dashboard/children",
            "/dashboard/children/:category",
            "/dashboard/children/:category/:id",
        ],
        element: <Page component={Children}/>,
    },
    {
        path: [
            "/dashboard/children",
            "/dashboard/children/progress/:studentId",
            "/dashboard/children/progress/:studentId/:id",
        ],
        element: <Page component={Progress}/>,
    },
    {
        path: [
            "/dashboard/appointments",
            "/dashboard/appointments/:category",
            "/dashboard/appointments/:category/:id",
        ],
        element: <Page component={Appointments}/>,
    },
    {
        path: [
            "/dashboard/bookings"
        ],
        element: <Page component={Bookings}/>,
    },
    {
        path: "/dashboard/programs",
        element: <Page component={Programs}/>,
    },
    {
        path: ["/dashboard/subscription",
            "/dashboard/subscription/:category"],
        element: <Page component={Subscription}/>,
    },
    {
        path: "/dashboard/profile",
        element: <Page component={Profile}/>,
    },
];

export default adminroutes;
